// initial state
import * as base from './base.js'
const baseName = '/admin/ordersType'

const ordersTypeList = baseName + '/list'
const ordersTypeAdd = baseName + '/add'
const ordersTypeEdit = baseName + '/edit'
const ordersTypeSelectLike = baseName + '/selectLike'


const obj = base.setBaseUrl('ordersType', baseName)
const obj1 = base.setBaseUrl('ordersTypeList', ordersTypeList)
const obj2 = base.setBaseUrl('ordersTypeAdd', ordersTypeAdd)
const obj3 = base.setBaseUrl('ordersTypeEdit', ordersTypeEdit)
const obj4 = base.setBaseUrl('ordersTypeSelectLike', ordersTypeSelectLike)

const a = Object.assign(obj, obj1, obj2, obj3,obj4,{ ordersTypeList, ordersTypeAdd,ordersTypeEdit,ordersTypeSelectLike})
export default a
